import type { TranslationDictionary } from "./types";

export const DE_DICTIONARY: TranslationDictionary = {
    "app.newTask": "Neu",
    "app.newTaskAria": "Neuer Chat",
    "sidebar.searchPlaceholder": "Suchaufforderungen oder Aufgabe ID",
    "sidebar.filters": "Aufgabenfilter",
    "sidebar.allRatios": "Alle Verhältnisse",
    "sidebar.allOrientations": "Alle Ausrichtungen",
    "sidebar.allModes": "Alle Modi",
    "sidebar.allResolutions": "Alle Vorsätze",
    "sidebar.activeTasks": "Aktive Aufgaben",
    "sidebar.topAnchors": "Top-Zeitnavigation",
    "sidebar.bottomAnchors": "Grundzeitnavigation",
    "sidebar.resize": "Größe der Seitenleiste ändern",
    "batch.selected": "0 ausgewählt",
    "batch.selectedCount": "{count} ausgewählt",
    "batch.archivedCount": "Archivierte {count}-Chats",
    "batch.archiveFailed": "Batch-Archivierung fehlgeschlagen",
    "batch.runningCannotDeleteSelected": "Ausgewählte Chats laufen und können nicht gelöscht werden",
    "batch.deleteTitle": "{count}-Chats löschen?",
    "batch.deleteMessage": "Dadurch werden auch lokale Bilddateien gelöscht.",
    "batch.deleteSkippedDetail": "{count} laufende Aufgaben bleiben erhalten",
    "batch.deleteSkippedSuffix": ", {count} laufende Aufgaben wurden nicht gelöscht",
    "batch.deletedCount": "Gelöschte {count} Chats{skipped}",
    "batch.deleteFailed": "Das Löschen im Stapel ist fehlgeschlagen",
    "action.archive": "Archiv",
    "action.delete": "Löschen",
    "action.cancel": "Abbrechen",
    "action.edit": "Bearbeiten",
    "action.clear": "Klar",
    "action.paste": "Einfügen",
    "action.find": "Finden",
    "action.replace": "Ersetzen",
    "action.close": "Schließen",
    "action.confirm": "Bestätigen",
    "action.confirmQuestion": "Aktion bestätigen?",
    "action.refresh": "Aktualisieren",
    "action.save": "Speichern",
    "action.add": "Hinzufügen",
    "action.new": "Neu",
    "action.import": "Importieren",
    "action.export": "Exportieren",
    "queue.empty": "Keine Warteschlange",
    "queue.emptyAria": "Warteschlangenstatus: Keine Aufgaben in der Warteschlange",
    "queue.jumpTitle": "Springen Sie zu aktiven Aufgaben",
    "queue.emptyTitle": "Keine Aufgaben in der Warteschlange",
    "queue.channel": "Kanäle {count}",
    "queue.availableChannels": "Verfügbare Kanäle {usable}/{total}",
    "queue.dispatching": "Terminplanung · Warten {waiting}",
    "queue.runningWaiting": "Läuft {running} · Warten {waiting}",
    "queue.statusLabel": "Warteschlangenstatus: {text} · {channelText}. Klicken Sie, um zu aktiven Aufgaben zu springen",
    "queue.runningActions": "Ausführen von Aufgabenwarteschlangenaktionen",
    "queue.waitingActions": "Warten auf Aktionen in der Aufgabenwarteschlange",
    "queue.cancelRunning": "Abbrechen",
    "queue.cancelRunningTitle": "Laufende Aufgabe abbrechen",
    "queue.dragWaiting": "Ziehen Sie, um die wartende Aufgabe neu anzuordnen",
    "queue.dragSort": "Zum Sortieren ziehen",
    "queue.moveUp": "Auf",
    "queue.moveUpTitle": "Warteaufgabe nach oben verschieben",
    "queue.moveDown": "Runter",
    "queue.moveDownTitle": "Warteaufgabe nach unten verschieben",
    "queue.promote": "Top",
    "queue.promoteTitle": "Warteaufgabe nach oben verschieben",
    "queue.promoteFailed": "Das Verschieben nach oben ist fehlgeschlagen",
    "queue.deleteWaitingShort": "Del",
    "queue.deleteWaitingTitle": "Wartende Aufgabe löschen",
    "queue.deleteWaitingTitleConfirm": "Wartende Aufgabe löschen?",
    "queue.deleteWaitingMessage": "Dadurch wird es aus der Warteschlange und der Verlaufsliste entfernt.",
    "queue.deleteQueuedFailed": "Die Aufgabe in der Warteschlange konnte nicht gelöscht werden",
    "queue.queuedDeleted": "Aufgabe in der Warteschlange gelöscht",
    "queue.cancelRunningConfirm": "Aufgabe abbrechen",
    "queue.cancelRunningTitleConfirm": "Laufende Aufgabe abbrechen?",
    "queue.cancelRunningMessage": "Die aktuelle Aufgabe wird gestoppt. Die Geschichte bleibt erhalten.",
    "queue.cancelRunningFailed": "Aufgabe konnte nicht abgebrochen werden",
    "queue.runningCancelled": "Aufgabe abgebrochen",
    "queue.reorderFailed": "Die Warteschlange konnte nicht neu angeordnet werden",
    "queue.realtimeUpdateFailed": "Der Live-Status konnte nicht aktualisiert werden",
    "queue.realtimeDisconnected": "Die Live-Statusverbindung wurde unterbrochen. Aktualisieren Sie die Seite, um sie wiederherzustellen.",
    "queue.readFailed": "Die Warteschlange konnte nicht geladen werden",
    "status.waiting": "Warten",
    "status.shownActiveTasks": "Aktive Aufgaben anzeigen",
    "status.jsonCopied": "JSON kopiert",
    "taskStatus.submitting": "Einreichen",
    "taskStatus.running": "Generieren",
    "taskStatus.runningWithElapsed": "Generieren · {elapsed}",
    "taskStatus.completed": "Abgeschlossen",
    "taskStatus.partialFailed": "Teilweise gescheitert",
    "taskStatus.failed": "Fehlgeschlagen",
    "taskStatus.queued": "In der Warteschlange",
    "taskStatus.unknown": "Unbekannter Status",
    "taskStatus.task": "Aufgabe",
    "taskStatus.connectionInterrupted": "Verbindung unterbrochen",
    "taskStatus.lastFailed": "Zuletzt gescheitert",
    "taskStatus.waitingRetry": "{reason}, wartet auf erneuten Versuch (Versuch {attempt}/{max})",
    "taskStatus.retrying": "{reason}, erneuter Versuch (Versuch {attempt}/{max})",
    "taskStatus.nonRetryableAttempt": "Versuch {attempt}/{max}, nicht wiederholbar",
    "taskStatus.manualRetryAvailable": "Angehalten; Fehlgeschlagene Bilder können manuell erneut versucht werden",
    "taskStatus.waitingRetryShort": "Wartet auf Retry",
    "taskStatus.retryingShort": "Retry läuft",
    "taskStatus.nonRetryableShort": "Nicht wiederholbar",
    "taskStatus.manualRetryShort": "Manuell retry",
    "taskStatus.stoppedShort": "Angehalten",
    "taskStatus.runtime": "Dauer {duration}",
    "taskStatus.runtimeCompleted": "Dauer {duration} · abgeschlossen {time}",
    "taskStatus.completedAt": "Abgeschlossen {time}",
    "taskCard.count": "{count} Bilder",
    "taskCard.successCount": "erfolgreich {count}",
    "taskCard.failedCount": "fehlgeschlagen {count}",
    "taskCard.runningCount": "Generieren von {count}",
    "taskCard.waitingCount": "warten {count}",
    "taskCard.textToImageThumb": "Miniaturansicht der Text-zu-Bild-Aufgabe",
    "taskCard.imageToImageThumb": "Miniaturansicht der Bild-zu-Bild-Aufgabe",
    "taskCard.failedThumb": "Aufgabe fehlgeschlagen",
    "taskCard.textBadge": "T",
    "taskMode.edit": "Bearbeiten",
    "taskMode.generate": "Generieren",
    "document.generatingQueue": "Generieren · Warteschlange {total}",
    "document.queuedWaiting": "In der Warteschlange · wartend {count}",
    "runFeedback.editing": "Bearbeiten",
    "runFeedback.generating": "Generieren",
    "runFeedback.status": "{action}, verstrichen {elapsed}",
    "footer.archive": "Archiv",
    "footer.archiveCount": "Archiv {count}",
    "footer.historyLibrary": "Geschichte",
    "historyLibrary.openFull": "Öffnen Sie die vollständige Geschichtsbibliothek",
    "history.documentTitle": "Geschichte – AGENTRA IMAGE",
    "history.back": "Zurück zum Generator",
    "history.title": "Geschichte",
    "history.loading": "Laden",
    "history.total": "{total} Aufgaben · {archived} archiviert",
    "history.search": "Suchen",
    "history.searchPlaceholder": "Suchaufforderungen oder Aufgabe ID",
    "history.clear": "Klar",
    "history.month": "Monat",
    "history.status": "Status",
    "history.promptMode": "Aufforderungsmodus",
    "history.size": "Größe",
    "history.quality": "Qualität",
    "history.ratio": "Verhältnis",
    "history.orientation": "Orientierung",
    "history.backend": "Backend",
    "history.provider": "Anbieter",
    "history.archived": "Archiviert",
    "history.all": "Alle",
    "history.allMonths": "Alle Monate",
    "history.allStatuses": "Alle Status",
    "history.allPromptModes": "Alle Modi",
    "history.allSizes": "Alle Größen",
    "history.allQualities": "Alle Qualitäten",
    "history.allRatios": "Alle Verhältnisse",
    "history.ratioOther": "Andere",
    "history.allOrientations": "Alle Ausrichtungen",
    "history.allBackends": "Alle Backends",
    "history.allProviders": "Alle Anbieter",
    "history.unarchived": "Nicht archiviert",
    "history.archivedOnly": "Archiviert",
    "history.tasksAria": "Historische Aufgaben",
    "history.taskListTitle": "Historische Aufgaben",
    "history.browseNewest": "Durchsuchen Sie zuerst das Neueste",
    "history.view": "Ansicht",
    "history.grid": "Gitter",
    "history.list": "Liste",
    "history.sort": "Sortieren",
    "history.newest": "Das Neueste zuerst",
    "history.oldest": "Älteste zuerst",
    "history.refresh": "Aktualisieren",
    "history.selectedCount": "{count} Aufgaben ausgewählt",
    "history.confirmDelete": "Bestätigen Sie das Löschen",
    "history.detail": "Aufgabendetails",
    "history.detailTitle": "Geschichtsaufgabe",
    "history.closeDetail": "Aufgabendetails schließen",
    "history.resizeFilters": "Größe der Filterseitenleiste ändern",
    "history.resizeDetail": "Größe des Detailbereichs ändern",
    "history.detailEmpty": "Wählen Sie eine historische Aufgabe aus, um Details anzuzeigen",
    "history.loadingDetail": "Details werden geladen...",
    "history.loadMore": "Mehr laden",
    "history.loadingMore": "Laden...",
    "history.noMore": "Keine Aufgaben mehr",
    "history.loadFailed": "Das Laden ist fehlgeschlagen. Aktualisieren Sie die Seite oder scrollen Sie weiter, um es noch einmal zu versuchen",
    "history.summaryFailed": "Zusammenfassung konnte nicht geladen werden",
    "history.tasksFailed": "Aufgaben konnten nicht geladen werden",
    "history.detailFailed": "Details konnten nicht geladen werden",
    "history.noMatches": "Keine passenden Aufgaben",
    "history.loadedCount": "{count} geladen",
    "history.windowNotice": "Die bereitgestellte Liste ist auf {count}-Aufgaben beschränkt. Scrollen Sie nach oben oder unten, um bei Bedarf benachbarte Aufgaben wiederherzustellen.",
    "history.selectTask": "Aufgabe auswählen",
    "history.viewing": "Anzeigen",
    "history.noPreview": "Keine Vorschaubilder",
    "history.downloadAll": "Herunterladen ZIP",
    "history.downloadSelected": "Download ausgewählt",
    "history.deleteUnselected": "Nicht ausgewähltes löschen",
    "history.confirmDeleteUnselected": "Bestätigen Sie, dass die Auswahl aufgehoben wurde",
    "history.selected": "Ausgewählt",
    "history.select": "Auswählen",
    "history.downloadIndex": "Herunterladen {index}",
    "history.addReference": "Referenz hinzufügen",
    "history.outputActions": "Ergebnisbildaktionen",
    "history.inputReferences": "Geben Sie Referenzen ein",
    "history.inputReferenceIndex": "Eingabereferenz {index}",
    "history.copyPrompt": "Eingabeaufforderung kopieren",
    "history.copyPrompts": "Eingabeaufforderungen kopieren",
    "history.copyPromptShort": "Kopieren",
    "history.copyPromptPanel": "Kopieren {title}",
    "history.copyOutputPromptPanel": "Bild kopieren {index} überarbeitete Eingabeaufforderung",
    "history.copyTaskIds": "Kopieren Sie die Aufgabe IDs",
    "history.reuseTask": "Im Generator anzeigen",
    "history.downloadTask": "Herunterladen",
    "history.downloadSelectedTasks": "Batch-Download",
    "history.contextMenuLabel": "Kontextmenü der Verlaufsaufgabe",
    "history.promptCopied": "Prompt kopiert",
    "history.promptsCopied": "Kopierte Eingabeaufforderungen von {count}-Aufgaben",
    "history.taskIdsCopied": "{count} Aufgabe IDs kopiert",
    "history.promptCopiedShort": "Kopiert",
    "history.promptCopyFailed": "Eingabeaufforderung konnte nicht kopiert werden",
    "history.promptCopyFailedShort": "Fehlgeschlagen",
    "history.noPrompt": "Für diese Aufgabe gibt es keine Aufforderung zum Kopieren",
    "history.noPromptShort": "Leer",
    "history.downloadStarted": "Download gestartet",
    "history.batchDownloadStarted": "Downloads für {count}-Aufgaben gestartet",
    "history.noDownloadableOutputs": "Keine herunterladbaren Bilder",
    "history.confirmDeleteSelected": "Bestätigen Sie den ausgewählten Löschvorgang",
    "history.openPreview": "Vorschau öffnen",
    "history.closePreview": "Vorschau schließen",
    "history.untitled": "Ohne Titel",
    "history.promptCompare": "Prompter Vergleich",
    "history.promptOriginal": "Ursprüngliche Aufforderung",
    "history.promptSubmitted": "Optimierte Eingabeaufforderung",
    "history.promptRevised": "Überarbeitetes Ergebnis",
    "history.outputRevisedPromptTitle": "Bild {index} überarbeitete Eingabeaufforderung",
    "history.outputRevisedPromptNotice": "Für jedes Bild gibt es unterhalb des Bildes eine eigene überarbeitete Eingabeaufforderung.",
    "history.promptEmpty": "Kein Inhalt",
    "history.promptMode.strict": "Streng",
    "history.promptMode.original": "Original",
    "history.promptMode.off": "Kreativ",
    "history.quality.high": "Hoch",
    "history.quality.medium": "Mittel",
    "history.quality.low": "Niedrig",
    "history.quality.auto": "Automatisch",
    "footer.batch": "Charge",
    "footer.storage": "Lagerung",
    "footer.apiStatus": "API Status: OK",
    "footer.version": "Version {version}",
    "footer.versionInfo": "Versionsinfo",
    "footer.versionLoading": "Version...",
    "footer.updateBadge": "Neue Version verfügbar",
    "footer.updateAvailable": "Neue Version {version}",
    "version.title": "Version & Update",
    "version.loading": "Versionsstatus lesen",
    "version.current": "Aktuelle Version",
    "version.latest": "Neueste Version",
    "version.source": "Laufzeit",
    "version.sourcePortable": "Tragbares Paket",
    "version.sourceSource": "Quellenprüfung",
    "version.upToDate": "Sie sind bereits auf der neuesten Version",
    "version.updateAvailable": "Version {version} ist verfügbar. Schließen Sie das WebUI-Serverfenster und führen Sie dann den Updater aus, um ein Upgrade durchzuführen.",
    "version.noUpdater": "Da es sich bei dieser Laufzeitumgebung nicht um ein portables Paket handelt, kann der Updater nicht automatisch gestartet werden.",
    "version.openUpdater": "Updater starten",
    "version.release": "Veröffentlichung ansehen",
    "version.updaterStarted": "Updater gestartet. Schließen Sie das aktuelle WebUI-Serverfenster und befolgen Sie dann die Anweisungen des Updaters.",
    "version.updaterFailed": "Der Updater konnte nicht gestartet werden. Führen Sie das Updater-Skript manuell aus dem Paket aus.",
    "notifications.title": "Benachrichtigungen",
    "notifications.unread": "Benachrichtigungen, {count} ungelesen",
    "notifications.unreadSummary": "{count} ungelesen",
    "notifications.empty": "Keine Aufgabenbenachrichtigungen",
    "notifications.taskFailed": "Aufgabe fehlgeschlagen",
    "notifications.taskPartial": "Aufgabe teilweise abgeschlossen",
    "notifications.taskCompleted": "Aufgabe abgeschlossen",
    "notifications.generationFailed": "Die Generierung ist fehlgeschlagen",
    "notifications.successCount": "{count} erfolgreich",
    "notifications.resultAvailable": "Ergebnisse verfügbar",
    "notifications.failedCount": "{count} fehlgeschlagen",
    "notifications.systemUnsupported": "Dieser Browser unterstützt keine Systembenachrichtigungen",
    "notifications.systemBlocked": "Systembenachrichtigungen werden vom Browser blockiert. Aktivieren Sie sie in den Browsereinstellungen.",
    "notifications.systemDenied": "Systembenachrichtigungen sind nicht aktiviert",
    "notifications.systemEnabled": "Systembenachrichtigungen aktiviert",
    "notifications.taskMissing": "Aufgabe existiert nicht oder wurde gelöscht",
    "theme.label": "Thema",
    "theme.system": "Automatisch",
    "theme.light": "Hell",
    "theme.dark": "Dunkel",
    "language.label": "Sprache der Benutzeroberfläche",
    "language.zh": "中",
    "language.zhCN": "简体中文",
    "language.zhTW": "正體中文",
    "language.zhHK": "繁体中文",
    "language.ja": "日本語",
    "language.ko": "한국어",
    "language.en": "English",
    "language.es": "Español",
    "language.pt": "Português",
    "language.fr": "Français",
    "language.de": "Deutsch",
    "language.ru": "Русский",
    "language.it": "Italiano",
    "language.hi": "हिन्दी",
    "auth.label": "Authentifizierungsquelle",
    "auth.checking": "Authentifizierung prüfen",
    "auth.missingCodexSession": "Keine Codex-Sitzung erkannt",
    "auth.switchFailed": "Der Wechsel der Authentifizierungsquelle ist fehlgeschlagen",
    "auth.sourceUnavailable": "{source} nicht verfügbar",
    "auth.notActive": "Nicht aktiv",
    "api.settings": "Systemeinstellungen",
    "api.provider": "API Anbieter",
    "imageInput.title": "Bilder",
    "imageInput.uploadAria": "Klicken Sie auf Bilder, legen Sie sie ab oder fügen Sie sie ein",
    "imageInput.uploadFull": "Klicken Sie auf Bilder, legen Sie sie ab oder fügen Sie sie ein",
    "imageInput.uploadCompact": "Bild hinzufügen",
    "imageInput.uploadSubtitle": "Mehrere Referenzbilder werden unterstützt",
    "imageInput.recent": "Aktuelle Uploads",
    "imageInput.recentBadge": "Neu",
    "imageInput.uploadBadge": "Hochladen",
    "imageInput.addToGallery": "Zur Galerie hinzufügen",
    "imageInput.addToGalleryShort": "Galerie",
    "imageInput.removeImage": "Bild entfernen",
    "imageInput.editedBadge": "Bearbeitet",
    "imageInput.editImage": "Bearbeiten {name}",
    "imageInput.deletedRecent": "Letzter Upload gelöscht",
    "imageInput.deletedGallery": "Galeriebild gelöscht",
    "recentAssets.defaultName": "Kürzlich hochgeladen",
    "recentAssets.use": "Verwenden Sie {name}",
    "recentAssets.delete": "{name} löschen",
    "recentAssets.deleteTitle": "Letzten Upload löschen?",
    "recentAssets.deleteMessage": "Dadurch wird das Bild aus den letzten Uploads entfernt. Wenn es derzeit als Bildeingabe ausgewählt ist, wird es aus der aktuellen Eingabe entfernt. Bei historischen Aufgaben, die auf diesen letzten Upload verweisen, geht die Eingabevorschau verloren. Die öffentliche Galerie ist nicht betroffen.",
    "recentAssets.loadFailed": "Die letzten Uploads konnten nicht geladen werden",
    "recentAssets.deleteFailed": "Der letzte Upload konnte nicht gelöscht werden",
    "recentAssets.deleted": "Letzter Upload gelöscht",
    "inputSource.uploadFallback": "Hochgeladenes Bild",
    "inputSource.galleryFallback": "Galeriebild",
    "inputSource.focusPasteFallback": "{prefix}. Die Bildeingabe ist fokussiert; Drücken Sie {shortcut}, um Bilder einzufügen.",
    "inputSource.pastedCount": "{count}-Bilder aus der Zwischenablage eingefügt",
    "inputSource.droppedCount": "{count} gelöschte Bilder hinzugefügt",
    "inputSource.dropImagesOnly": "Nur Bilddateien löschen",
    "inputSource.clipboardUnsupported": "Dieser Browser kann die Zwischenablage nicht direkt lesen",
    "inputSource.clipboardEmpty": "Keine Bilder in der Zwischenablage gefunden",
    "inputSource.clipboardDenied": "Der Browser hat den direkten Zugriff auf die Zwischenablage blockiert",
    "inputSource.clipboardReadFailed": "Die Zwischenablage konnte nicht gelesen werden",
    "status.missingGalleryReference": "Ein Galerie-Referenzbild wurde gelöscht. Entfernen Sie es vor dem Generieren.",
    "status.missingRecentReference": "Ein kürzlich hochgeladenes Referenzbild wurde gelöscht. Entfernen Sie es vor dem Generieren.",
    "status.emptyPrompt": "Geben Sie eine Eingabeaufforderung ein",
    "status.editNeedsImage": "Für den Bearbeitungsmodus ist mindestens ein Bild erforderlich",
    "status.loadedTask": "Geladene Aufgabe {taskId}",
    "status.reusedTask": "Aufgabe {taskId} im Generator geöffnet",
    "status.loadingHistoryInputs": "Historische Eingabebilder werden geladen...",
    "status.historyInputLoadFailed": "Historisches Eingabebild konnte nicht geladen werden: {url}",
    "referenceCollector.alreadyStaged": "Bereits als Referenz inszeniert",
    "referenceCollector.staged": "Inszenierte {count}-Referenzbilder",
    "referenceCollector.title": "Ausstehende Referenzen · {count}",
    "referenceCollector.addAll": "Fügen Sie alle Referenzen hinzu",
    "referenceCollector.itemFallback": "Ausstehende Referenz",
    "referenceCollector.remove": "Ausstehende Referenz entfernen",
    "referenceCollector.cleared": "Ausstehende Referenzen gelöscht",
    "referenceCollector.added": "{count}-Referenzbilder hinzugefügt",
    "referenceCollector.addFailed": "Ausstehende Referenzen konnten nicht hinzugefügt werden",
    "referenceCollector.readFailed": "Bild konnte nicht gelesen werden: {status}",
    "gallery.quick": "Schnelle Galerie",
    "gallery.current": "Aktuelle Kategoriegalerie",
    "gallery.categories": "Galeriekategorien",
    "gallery.categoryPortrait": "Porträt",
    "gallery.categoryCharacter": "Charakter",
    "gallery.categoryProduct": "Produkt",
    "gallery.categoryPortraitRole": "Porträtreferenz",
    "gallery.categoryCharacterRole": "Charakterreferenz",
    "gallery.categoryProductRole": "Produktreferenz",
    "gallery.referenceRole": "Referenzbild",
    "gallery.manage": "Galerie verwalten",
    "gallery.loadFailed": "Galerie konnte nicht geladen werden",
    "gallery.imageOrderUpdateFailed": "Bildreihenfolge konnte nicht aktualisiert werden",
    "gallery.imageOrderUpdated": "Bildreihenfolge aktualisiert",
    "gallery.categoryName": "Kategoriename",
    "gallery.categoryPromptRole": "Schnelle Rolle",
    "gallery.categorySave": "Speichern",
    "gallery.categoryDelete": "Löschen",
    "gallery.categoryLoadFailed": "Kategorien konnten nicht geladen werden",
    "gallery.categoryNameRequired": "Geben Sie einen Kategorienamen ein",
    "gallery.categoryCreateFailed": "Kategorie konnte nicht hinzugefügt werden",
    "gallery.categoryCreated": "Kategorie hinzugefügt",
    "gallery.categorySaveFailed": "Kategorie konnte nicht gespeichert werden",
    "gallery.categorySaved": "Kategorie gespeichert",
    "gallery.categoryDeleteTitle": "Galeriekategorie löschen?",
    "gallery.categoryDeleteMessage": "Bilder in dieser Kategorie werden in eine andere Kategorie verschoben. Galeriebilder werden nicht gelöscht.",
    "gallery.categoryDeleteConfirm": "Kategorie löschen",
    "gallery.categoryDeleteFailed": "Kategorie konnte nicht gelöscht werden",
    "gallery.categoryDeletedMigrated": "Kategorie „{name}“ gelöscht und Bilder migriert",
    "gallery.categoryOrderUpdateFailed": "Die Kategoriereihenfolge konnte nicht aktualisiert werden",
    "gallery.categoryOrderUpdated": "Kategoriereihenfolge aktualisiert",
    "gallery.categoryFallback": "Kategorie „Galerie“.",
    "gallery.imageFallback": "Galeriebild",
    "gallery.imageLoadFailed": "Dieses Bild konnte nicht geladen werden",
    "gallery.editImageLoadFailed": "Dieses Bild konnte nicht zur Bearbeitung geladen werden",
    "gallery.cannotAddImage": "Dieses Bild kann nicht zur Galerie hinzugefügt werden",
    "gallery.nameRequired": "Geben Sie einen Galerienamen ein",
    "gallery.saveFailed": "Das Galeriebild konnte nicht gespeichert werden",
    "gallery.savedAsReference": "Zur Galerie hinzugefügt und zur Galeriereferenz gewechselt",
    "gallery.renameImage": "Galeriebild umbenennen",
    "gallery.moveToCategory": "Zur Kategorie wechseln",
    "gallery.categoryRequired": "Wählen Sie eine Galeriekategorie",
    "gallery.promptNoteTitle": "Referenzhinweis zur Galerie",
    "gallery.updateFailed": "Galerie konnte nicht aktualisiert werden",
    "gallery.selectImageFile": "Wählen Sie eine Bilddatei",
    "gallery.replaceImageFailed": "Das Galeriebild konnte nicht ersetzt werden",
    "gallery.replacedImage": "Das Quellbild für „{name}“ wurde ersetzt.",
    "gallery.deleteImageTitle": "Galeriebild löschen?",
    "gallery.deleteImageMessage": "Historische Aufgabenverweise werden als gelöscht angezeigt.",
    "gallery.deleteFailed": "Das Galeriebild konnte nicht gelöscht werden",
    "gallery.deletedSuffix": "(gelöscht)",
    "gallery.editImageLabel": "Galeriebild bearbeiten",
    "gallery.fieldCategory": "Kategorie",
    "gallery.fieldPromptNote": "Referenzhinweis",
    "gallery.fieldName": "Name",
    "quickGallery.empty": "Keine {category}-Bilder",
    "promptGallery.remove": "Entfernen Sie @{name}",
    "prompt.title": "Prompt",
    "prompt.editorLabel": "Prompt",
    "prompt.placeholder": "Beschreiben Sie das Bild, das Sie erstellen oder bearbeiten möchten. Geben Sie @ für Galeriereferenzen, # für Farbcodes und ~ für Eingabeaufforderungsausschnitte ein.",
    "prompt.run": "Generieren",
    "prompt.runEdit": "Beginnen Sie mit der Bearbeitung",
    "prompt.runTitle": "Generieren (Cmd+Enter)",
    "prompt.runEditTitle": "Mit der Bearbeitung beginnen (Cmd+Enter)",
    "prompt.findPanel": "Aufforderung zum Suchen und Ersetzen",
    "prompt.findText": "Text finden",
    "prompt.replaceWith": "Ersetzen durch",
    "prompt.findActions": "Suchen und ersetzen Sie Aktionen",
    "prompt.countZero": "0 Übereinstimmungen",
    "prompt.matchCount": "{count} stimmt überein",
    "prompt.foundCount": "Es wurden {count}-Übereinstimmungen gefunden",
    "prompt.noMatch": "Kein passender Text",
    "prompt.replacedCount": "Ersetzte {count}-Übereinstimmungen",
    "prompt.closeFind": "Schließen Sie Suchen und Ersetzen",
    "prompt.recentTemplates": "Aktuelle Vorlagen",
    "prompt.manageTemplates": "Vorlagen verwalten",
    "promptModel.galleryHeader": "Referenzbildhinweise:",
    "promptModel.galleryInstruction": "- Referenzbild {number}: Galerie „{name}“, Rolle: {role}. @{name} in der Eingabeaufforderung bezieht sich auf dieses Bild.{note}",
    "outputSettings.title": "Ausgabe",
    "output.mainModel": "Hauptmodell",
    "output.selectMainModel": "Hauptmodell auswählen",
    "output.mainModelCustomForInput": "Verwenden Sie ein benutzerdefiniertes Modell für die aktuelle Eingabe",
    "output.apiDirect": "API Direkt",
    "output.apiToolModel": "Verwendung des Bildmodells API",
    "output.mainModelUnused": "Das Hauptmodell wird für diese Anfrage nicht verwendet",
    "output.webSearch": "Websuche",
    "output.webSearchToggle": "Auf",
    "output.webSearchTitle": "Durchsuchen Sie zuerst das Internet und nutzen Sie es dann für diese Generation. Nur Codex und API Responses",
    "output.promptMode": "Aufforderungsmodus",
    "output.modeOriginal": "Original",
    "output.modeStrict": "Treu",
    "output.modeCreative": "Kreativ",
    "output.sizeMode": "Größenmodus",
    "output.sizePreset": "Voreingestellt",
    "output.sizeCustom": "Benutzerdefiniert",
    "output.orientation": "Orientierung",
    "output.square": "Quadratisch",
    "output.portrait": "Porträt",
    "output.landscape": "Landschaft",
    "output.resolution": "Auflösung",
    "output.pixelSize": "Pixelgröße",
    "output.width": "Breite",
    "output.height": "Höhe",
    "output.swapSize": "Breite und Höhe tauschen",
    "output.customSizeHint": "Einheit px · 16-3840 · Vielfaches von 16 · ≤3:1",
    "output.imageSizeUnavailable": "Bildgröße nicht verfügbar",
    "output.imageLoadFailed": "Das Bild konnte nicht geladen werden",
    "output.customSizeRequired": "Geben Sie Breite und Höhe ein",
    "output.customSizeBounds": "Breite und Höhe müssen 16–3840 Pixel betragen",
    "output.customSizeMultiple": "Breite und Höhe müssen ein Vielfaches von 16 sein",
    "output.customSizeRatio": "Das Verhältnis der langen zur kurzen Seite darf 3:1 nicht überschreiten",
    "output.customSizePixels": "Die Gesamtpixelzahl muss zwischen 655.360 und 8.294.400 liegen",
    "output.ratioLock": "Übersetzungssperre (optional)",
    "output.customRatio": "Benutzerdefiniertes Seitenverhältnis",
    "output.ratioWidth": "W",
    "output.ratioHeight": "H",
    "output.firstImageRatio": "Verwenden Sie das erste Referenzbild-Seitenverhältnis",
    "output.useFirstImage": "Aus Bild",
    "output.ratioHint": "Für freie Größe leer lassen · Füllen Sie beide Felder aus, um sie zu synchronisieren",
    "output.ratio": "Verhältnis",
    "output.quality": "Qualität",
    "output.qualityAuto": "Automatisch",
    "output.qualityLow": "Niedrig",
    "output.qualityMedium": "Mittel",
    "output.qualityHigh": "Hoch",
    "output.quantity": "Zählen",
    "output.pixelPreview": "Ausgabepixel: 1024 x 1024 Pixel",
    "output.pixelPreviewValue": "Ausgabepixel: {value}",
    "output.pixelPreviewAuto": "Ausgabepixel: automatisch (OpenAI wählt automatisch)",
    "output.format": "Formatieren",
    "output.compression": "Komprimierung",
    "output.moderation": "Moderation",
    "preview.title": "Vorschau",
    "preview.selectedZero": "0 ausgewählt",
    "preview.selectedCount": "Ausgewählt {selected}/{total}",
    "preview.downloadSelected": "Download ausgewählt",
    "preview.deleteUnselected": "Nicht ausgewähltes löschen",
    "preview.downloadAll": "Herunterladen ZIP",
    "preview.empty": "Noch keine Bilder",
    "preview.taskFailed": "Aufgabe fehlgeschlagen",
    "preview.partialFailed": "Einige Bilder sind fehlgeschlagen",
    "preview.failedOutput": "Bild {index} ist fehlgeschlagen",
    "preview.progressLine": "Abgeschlossen {generated} / {total} · abgelaufen {elapsed}",
    "preview.failureLine": "Abgeschlossen {generated} / {total} · fehlgeschlagen {failed}",
    "preview.elapsedLine": "Vergangen {elapsed}",
    "preview.lastError": "Letzter Fehler: {error}",
    "preview.continueGenerating": "Weiterführende Generation",
    "preview.waitingContinue": "Ich warte darauf, fortzufahren",
    "preview.retryFailed": "Versuchen Sie es erneut mit fehlgeschlagenen Bildern",
    "preview.acceptSuccesses": "Akzeptieren Sie erfolgreiche Ergebnisse",
    "preview.generateMode": "Generation",
    "preview.editMode": "Bearbeiten",
    "preview.runningTitle": "{mode} läuft",
    "preview.submittingTitle": "Aufgabe senden",
    "preview.queuedTitle": "Aufgabe in der Warteschlange",
    "preview.submittingDetail": "Eingaben speichern und die Aufgabe zur Warteschlange hinzufügen. Die Generierung startet automatisch.",
    "preview.queuedDetail": "Die Aufgabe befindet sich in der Warteschlange und wartet auf einen verfügbaren Kanal.",
    "preview.featured": "Ausgewählt",
    "preview.addFeatured": "Ergebnis auswählen",
    "preview.selectedFeatured": "Ausgewählt",
    "preview.removeFeatured": "Ergebnis abwählen",
    "preview.selectionAdded": "Ergebnis ausgewählt",
    "preview.selectionRemoved": "Ergebnis abgewählt",
    "preview.selectionUpdateFailed": "Auswahl konnte nicht aktualisiert werden",
    "preview.noUnselectedOutputs": "Keine nicht ausgewählten Bilder zum Löschen vorhanden",
    "preview.deleteUnselectedTitle": "Nicht ausgewählte Bilder löschen?",
    "preview.deleteUnselectedMessage": "Dadurch werden lokale Bilddateien für nicht ausgewählte Ergebnisse in dieser Aufgabe gelöscht.",
    "preview.deleteUnselectedDetail": "{selected} behalten, {deleted} löschen",
    "preview.deleteUnselectedFailed": "Nicht ausgewählte Bilder konnten nicht gelöscht werden",
    "preview.deleteUnselectedDone": "Nicht ausgewählte Bilder gelöscht",
    "preview.addReference": "Referenz hinzufügen",
    "preview.stage": "Bühne",
    "preview.stageReference": "Stufe als ausstehende Referenz",
    "preview.prompt": "Prompt",
    "preview.download": "Herunterladen",
    "preview.downloadImage": "Laden Sie dieses Bild herunter",
    "lightbox.label": "Bildvorschau",
    "lightbox.close": "Vorschau schließen",
    "lightbox.previous": "Vorheriges Bild",
    "lightbox.next": "Nächstes Bild",
    "promptPopover.title": "Schneller Vergleich",
    "promptPopover.summary": "Original {original} · optimiert {optimized}",
    "promptPopover.original": "Ursprüngliche Aufforderung",
    "promptPopover.optimized": "Optimierte Eingabeaufforderung",
    "promptPopover.charCount": "{count} Zeichen",
    "promptPopover.empty": "Keine",
    "promptPopover.notReturned": "Nicht zurückgegeben",
    "promptPopover.noOptimized": "Es wurde keine optimierte Eingabeaufforderung zurückgegeben",
    "promptPopover.submitted": "Gesendete Eingabeaufforderung anzeigen",
    "promptPopover.close": "Schneller Vergleich schließen",
    "promptPopover.copyOptimized": "Optimierte Eingabeaufforderung kopieren",
    "promptPopover.copied": "Kopiert",
    "taskContext.menuLabel": "Aufgabenkontextmenü",
    "taskContext.view": "Aufgabe ansehen",
    "taskContext.copyId": "Kopieraufgabe ID",
    "taskContext.copyPrompt": "Eingabeaufforderung kopieren",
    "taskContext.revealOutput": "Ausgabeordner öffnen",
    "taskContext.archive": "Archivierungsaufgabe",
    "taskContext.delete": "Aufgabe löschen",
    "taskContext.idCopied": "Aufgabe ID kopiert",
    "taskContext.promptCopied": "Prompt kopiert",
    "taskContext.noPrompt": "Für diese Aufgabe gibt es keine Aufforderung zum Kopieren",
    "taskContext.revealFailed": "Ausgabeordner konnte nicht geöffnet werden",
    "taskContext.revealOpened": "Ausgabeordner geöffnet",
    "taskContext.actionFailed": "Die Aufgabenaktion ist fehlgeschlagen",
    "taskActions.group": "Aufgabenaktionen",
    "taskActions.deleteTitle": "Aufgabe löschen?",
    "taskActions.deleteMessage": "Dadurch werden auch lokale Bilddateien gelöscht.",
    "taskActions.runningCannotDelete": "Laufende Aufgaben können nicht gelöscht werden",
    "taskActions.updated": "Aufgabenstatus aktualisiert",
    "taskActions.archived": "Chat archiviert",
    "taskActions.archiveFailed": "Archivierung fehlgeschlagen",
    "taskActions.deleted": "Aufgabe gelöscht",
    "taskActions.deleteFailed": "Das Löschen ist fehlgeschlagen",
    "taskActions.noRetryableFailedImages": "Für diese Aufgabe sind keine fehlgeschlagenen Bilder vorhanden, die wiederholt werden könnten",
    "taskActions.retryFailedOutputsFailed": "Fehler beim erneuten Versuch der Bilder",
    "taskActions.requeuedFailedImages": "Fehlerhafte Bilder wurden erneut in die Warteschlange gestellt",
    "taskActions.noAcceptableSuccessImages": "Für diese Aufgabe sind keine erfolgreichen Bilder vorhanden",
    "taskActions.acceptSuccessesFailed": "Erfolgreiche Ergebnisse konnten nicht akzeptiert werden",
    "taskActions.acceptedSuccesses": "Erfolgreiche Ergebnisse akzeptiert",
    "taskActions.viewedUpdateFailed": "Der Lesestatus konnte nicht aktualisiert werden",
    "taskActions.failedFallback": "Aufgabe fehlgeschlagen",
    "taskList.empty": "Noch keine Geschichte",
    "taskList.selectSession": "Wählen Sie Chat aus",
    "taskList.unreadUpdate": "Ungelesenes Update",
    "taskList.viewing": "Anzeigen",
    "taskDerived.usageLimited": "Nutzung begrenzt",
    "taskSubmit.requestFailed": "Die Anfrage ist fehlgeschlagen",
    "taskSubmit.queued": "Aufgabe zur Warteschlange hinzugefügt",
    "taskSubmit.timeout": "Beim Senden der Aufgabe ist eine Zeitüberschreitung aufgetreten, bevor das Backend geantwortet hat. Aktualisieren Sie die Warteschlange, um zu bestätigen, ob sie hinzugefügt wurde, und entscheiden Sie dann, ob Sie es erneut versuchen möchten.",
    "taskSubmit.failed": "Die Übermittlung der Aufgabe ist fehlgeschlagen",
    "templates.title": "Eingabeaufforderungsvorlagen",
    "templates.summary": "Lokale Vorlagenbibliothek",
    "templates.availableCount": "{count} verfügbare Vorlagen",
    "templates.noMatch": "Keine passenden Vorlagen",
    "templates.empty": "Keine Vorlagen",
    "templates.favoriteBadge": "Favorit",
    "templates.usageCount": "{count} verwendet",
    "templates.back": "Zurück",
    "templates.edit": "Bearbeiten",
    "templates.copy": "Kopieren",
    "templates.insert": "Einfügen",
    "templates.formTitle": "Titel",
    "templates.formShortTitle": "Kurztitel",
    "templates.formCategory": "Kategorie",
    "templates.formTags": "Schlagworte",
    "templates.formThumbnail": "Miniaturansicht",
    "templates.formContent": "Inhalt",
    "templates.formNotes": "Notizen",
    "templates.formFavorite": "Favorit",
    "templates.thumbnailClear": "Klar",
    "templates.thumbnailNone": "Keine ausgewählt",
    "templates.thumbnailEmpty": "Keine Miniaturansichten des Verlaufs",
    "templates.newCategory": "Neue Kategorie",
    "templates.search": "Suchen Sie nach Vorlagen, Tags oder Inhalten",
    "templates.filter": "Vorlagenfilter",
    "templates.all": "Alle",
    "templates.categoryCommon": "Gewöhnlich",
    "templates.categoryPortrait": "Porträt",
    "templates.categoryProduct": "Produkt",
    "templates.categoryRepair": "Reparieren",
    "templates.categoryPoster": "Plakat",
    "templates.categoryEcommerce": "E-Commerce",
    "templates.favorite": "Favoriten",
    "templates.recent": "Neu",
    "templates.category": "Kategorien",
    "templates.loadFailed": "Eingabeaufforderungsvorlagen konnten nicht geladen werden",
    "templates.useStateUpdateFailed": "Der Nutzungsstatus der Eingabeaufforderungsvorlage konnte nicht aktualisiert werden",
    "templates.copied": "Eingabeaufforderungsvorlage kopiert",
    "templates.copyFailed": "Eingabeaufforderungsvorlage konnte nicht kopiert werden",
    "templates.history": "Geschichte",
    "templates.saveFailed": "Eingabeaufforderungsvorlage konnte nicht gespeichert werden",
    "templates.saved": "Eingabeaufforderungsvorlage gespeichert",
    "templates.deleteFailed": "Eingabeaufforderungsvorlage konnte nicht gelöscht werden",
    "templates.deleted": "Eingabeaufforderungsvorlage gelöscht",
    "templates.categoryAddFailed": "Die Vorlagenkategorie konnte nicht hinzugefügt werden",
    "templates.categoryAdded": "Vorlagenkategorie hinzugefügt",
    "templates.categorySaveFailed": "Vorlagenkategorie konnte nicht gespeichert werden",
    "templates.categorySaved": "Vorlagenkategorie gespeichert",
    "templates.categoryDeleteFailed": "Die Vorlagenkategorie konnte nicht gelöscht werden",
    "templates.categoryDeleted": "Vorlagenkategorie gelöscht",
    "templates.importFailed": "Vorlagenpaket konnte nicht importiert werden",
    "templates.importedCount": "Importierte {count}-Vorlagen",
    "templates.exportFailed": "Das Exportieren des Vorlagenpakets ist fehlgeschlagen",
    "templates.exported": "Vorlagenpaket exportiert",
    "snippets.suggestLabel": "Schnelle Snippet-Auswahl",
    "snippets.saveSelection": "Speichern",
    "snippets.saveSelectionLabel": "Ausgewählten Text als Eingabeaufforderungsausschnitt speichern",
    "snippets.popoverLabel": "Prompter Ausschnitt",
    "snippets.defaultCategory": "Gewöhnlich",
    "snippets.loadFailed": "Eingabeaufforderungsausschnitte konnten nicht geladen werden",
    "snippets.remove": "Entfernen Sie ~{tag}",
    "snippets.expand": "Erweitern",
    "snippets.edit": "Bearbeiten",
    "snippets.close": "Schließen",
    "snippets.editTitle": "Snippet bearbeiten",
    "snippets.saveTitle": "Ausschnitt speichern",
    "snippets.shortTag": "Kurzes Etikett",
    "snippets.title": "Titel",
    "snippets.category": "Kategorie",
    "snippets.content": "Inhalt",
    "snippets.titlePlaceholder": "Verwendet standardmäßig ein kurzes Tag",
    "snippets.cancel": "Abbrechen",
    "snippets.save": "Speichern",
    "snippets.saveFailed": "Eingabeaufforderungsausschnitt konnte nicht gespeichert werden",
    "snippets.saved": "Eingabeaufforderungsausschnitt gespeichert",
    "snippets.defaultTag": "Allgemeiner Ausschnitt",
    "colors.white": "Weiß",
    "colors.black": "Schwarz",
    "colors.warmBeige": "Warmes Beige",
    "colors.lightGreen": "Hellgrün",
    "colors.brandGreen": "Marke grün",
    "colors.peachOrange": "Pfirsichorange",
    "colors.lightBlue": "Hellblau",
    "colors.lightPink": "Hellrosa",
    "colors.loadFailed": "Farbeinstellungen konnten nicht geladen werden",
    "colors.saveFailed": "Farbeinstellungen konnten nicht gespeichert werden",
    "colors.importFailed": "Farbeinstellungen konnten nicht importiert werden",
    "colors.importedCount": "Importierte {count}-Farben",
    "colors.recentSaveFailed": "Die letzten Farben konnten nicht gespeichert werden",
    "colors.favoriteSaveFailed": "Lieblingsfarbe konnte nicht gespeichert werden",
    "colors.favoriteDeleteFailed": "Die Lieblingsfarbe konnte nicht gelöscht werden",
    "colors.update": "Aktualisieren",
    "colors.insert": "Einfügen",
    "colors.pick": "Wählen Sie Farbe",
    "colors.pickShort": "Wählen",
    "colors.hexValue": "Farbwert",
    "colors.pendingUpdate": "Farbe geändert. Klicken Sie zum Anwenden auf „Aktualisieren“.",
    "colors.save": "Speichern",
    "colors.exportPs": "Exportieren",
    "colors.importPs": "Importieren",
    "colors.done": "Fertig",
    "colors.manage": "Verwalten",
    "colors.favorites": "Lieblingsfarben",
    "colors.recent": "Aktuelle Farben",
    "colors.recentLabel": "Neu",
    "colors.deleteFavorite": "Lieblingsfarbe löschen {name}",
    "colors.modify": "Farbe bearbeiten",
    "colors.modifyValue": "Farbe bearbeiten {value}",
    "colors.removeValue": "Farbe entfernen {value}",
    "taskGroup.today": "Heute",
    "taskGroup.yesterday": "Gestern",
    "taskGroup.last7": "Letzte 7 Tage",
    "taskGroup.older": "Älter",
    "taskGroup.searchResults": "Suchergebnisse",
    "taskGroup.active": "Aktiv",
    "taskGroup.running": "Laufen",
    "taskGroup.waiting": "Warten",
    "taskGroup.dispatchPending": "Einen verfügbaren Kanal zuweisen...",
    "taskGroup.expand": "Erweitern {label}",
    "taskGroup.collapse": "Zusammenbruch {label}",
    "taskGroup.buttonLabel": "{label}, {count} Aufgaben",
    "archive.title": "Archiv",
    "archive.empty": "Keine archivierten Chats",
    "archive.count": "{count} archivierte Chats",
    "archive.restore": "Wiederherstellen",
    "archive.archiveFailed": "Archivierung fehlgeschlagen",
    "archive.restoreFailed": "Wiederherstellung fehlgeschlagen",
    "archive.restored": "Chat wiederhergestellt",
    "archive.archiving": "Archivierung...",
    "archive.restoring": "Wiederherstellung...",
    "archive.deleting": "Löschen...",
    "archive.restoredCount": "{count}-Aufgaben wiederhergestellt",
    "settings.title": "Lagerung",
    "settings.status": "Starten Sie WebUI neu, nachdem Sie die Speicherpfade gespeichert haben",
    "settings.inputRoot": "Eingabeordner",
    "settings.outputRoot": "Ausgabeordner",
    "settings.galleryRoot": "Galerieordner",
    "settings.sourceDataRoot": "Quelldatenordner",
    "settings.chooseDirectory": "Ordner auswählen",
    "settings.language": "Schnittstellensprache",
    "settings.languageCopy": "Beim ersten Start folgt die Benutzeroberfläche Ihrer Browsersprache. Manuelle Entscheidungen werden gespeichert.",
    "settings.notificationsCopy": "Benachrichtigen Sie, wenn Aufgaben abgeschlossen sind oder fehlschlagen. Systembenachrichtigungen müssen manuell aktiviert werden.",
    "settings.inAppNotification": "In-App-Benachrichtigungen",
    "settings.systemNotification": "Systembenachrichtigungen",
    "settings.save": "Einstellungen speichern",
    "settings.loadFailed": "Die Einstellungen konnten nicht geladen werden",
    "settings.saveFailed": "Einstellungen konnten nicht gespeichert werden",
    "settings.savedRestart": "Speichereinstellungen gespeichert. Starten Sie WebUI neu, um es anzuwenden.",
    "settings.saved": "Gespeichert",
    "settings.savedRestartStatus": "Speichereinstellungen gespeichert. Starten Sie WebUI neu, um es anzuwenden.",
    "systemSettings.title": "Systemeinstellungen",
    "systemSettings.tabsLabel": "Abschnitte mit den Systemeinstellungen",
    "systemSettings.apiTab": "API Einstellungen",
    "systemSettings.codexTab": "Codex Kanal",
    "systemSettings.languageTab": "Sprache / Language",
    "systemSettings.storageTab": "Benachrichtigungen",
    "languageSettings.instantStatus": "Sprachänderungen gelten ab sofort",
    "apiSettings.title": "API Einstellungen",
    "apiSettings.status": "Gespeicherte Einstellungen gelten sofort im API-Modus",
    "apiSettings.codexMode": "Codex Kanal",
    "apiSettings.codexImages": "Image",
    "apiSettings.codexResponses": "Responses",
    "apiSettings.providers": "API Anbieter",
    "apiSettings.providerCount": "{count} Anbieter",
    "apiSettings.provider": "Anbieter",
    "apiSettings.providerName": "Anbietername",
    "apiSettings.newProviderAction": "Neuer Anbieter",
    "apiSettings.copyProvider": "Kopieren",
    "apiSettings.copyProviderName": "{name} Kopie",
    "apiSettings.copyProviderStatus": "Der Anbieter hat mit seinem gespeicherten Schlüssel kopiert. Bearbeiten Sie vor dem Speichern den Namen, das Modell oder ersetzen Sie den Schlüssel.",
    "apiSettings.copyProviderWithoutKeyStatus": "Anbieter kopiert. Bearbeiten Sie vor dem Speichern den Namen und das Modell oder fügen Sie einen API-Schlüssel hinzu.",
    "apiSettings.sortProviders": "Sortieren",
    "apiSettings.finishSortProviders": "Fertig",
    "apiSettings.sortProviderModeStatus": "Sortieranbieter",
    "apiSettings.sortProviderStatus": "Anbieterauftrag geändert. Speichern Sie die aktuelle Auswahl, um sie zu synchronisieren.",
    "apiSettings.moveProviderUp": "Auf",
    "apiSettings.moveProviderDown": "Runter",
    "apiSettings.moveProviderUpAria": "Verschieben Sie {provider} nach oben",
    "apiSettings.moveProviderDownAria": "Verschieben Sie {provider} nach unten",
    "apiSettings.mode": "Anforderungsmodus",
    "apiSettings.images": "Direktes Bild API",
    "apiSettings.responses": "Responses API",
    "apiSettings.modeImagesShort": "Direkt",
    "apiSettings.imageModel": "Bildmodell",
    "apiSettings.concurrency": "Parallelitätslimit des Anbieters",
    "apiSettings.concurrencyShort": "Parallelität",
    "apiSettings.concurrencyValue": "Parallelität {concurrency}",
    "apiSettings.keySaved": "API Schlüssel gespeichert",
    "apiSettings.keyNotSet": "Schlüssel API nicht gesetzt",
    "apiSettings.editProvider": "Anbieter bearbeiten",
    "apiSettings.newProviderTitle": "Neuer Anbieter",
    "apiSettings.editHint": "Der Speicheranbieter schreibt diese Änderung in das Backend. Abbrechen verwirft es.",
    "apiSettings.finishEditFirst": "Speichern oder brechen Sie zunächst die aktuelle Anbieterbearbeitung ab",
    "apiSettings.newDraftStatus": "Anbieter erstellen. Anbieter speichern, um sich zu bewerben.",
    "apiSettings.editDraftStatus": "Bearbeitungsanbieter. Anbieter speichern, um sich zu bewerben.",
    "apiSettings.cancelEdit": "Bearbeitung abbrechen",
    "apiSettings.saveProvider": "Anbieter speichern",
    "apiSettings.saveSelection": "Auswahl speichern",
    "apiSettings.deleteProviderTitle": "Anbieter löschen?",
    "apiSettings.deleteProviderMessage": "„{provider}“ löschen?",
    "apiSettings.deleteProviderDetail": "Dadurch wird es aus der Anbieterliste entfernt. Speichern Sie die aktuelle Auswahl, um sie mit dem Backend zu synchronisieren.",
    "apiSettings.deleteProviderStatus": "Anbieter gelöscht. Speichern Sie die aktuelle Auswahl, um sie mit dem Backend zu synchronisieren.",
    "apiSettings.save": "Speichern Sie die API-Einstellungen",
    "apiSettings.loadFailed": "Die Einstellungen für API konnten nicht geladen werden",
    "apiSettings.savedKeyPlaceholder": "Der Schlüssel API wird im Backend gespeichert. Geben Sie einen neuen Schlüssel ein, um ihn zu ersetzen.",
    "apiSettings.newProvider": "Neuer Anbieter",
    "apiSettings.saving": "Sparen...",
    "apiSettings.savingStatus": "API-Einstellungen werden gespeichert...",
    "apiSettings.saveFailed": "Die Einstellungen für API konnten nicht gespeichert werden",
    "apiSettings.savedSummary": "Gespeichert · Codex {codex} · API {provider} · {mode} · {model} · Parallelität {concurrency}",
    "apiSettings.savedShort": "Gespeichert",
    "apiSettings.savedStatus": "API Einstellungen gespeichert",
    "apiSettings.saveFailedShort": "Speichern fehlgeschlagen",
    "codexSettings.title": "Codex Kanal",
    "codexSettings.status": "Wählen Sie den Generierungskanal für die lokale Codex-Anmeldung",
    "codexSettings.notesLabel": "Codex Kanalnotizen",
    "codexSettings.imagesTitle": "Image",
    "codexSettings.imagesCopy": "Standardkanal zur direkten Übergabe von Größe, Qualität und Bearbeitungsparametern.",
    "codexSettings.responsesTitle": "Responses",
    "codexSettings.responsesCopy": "Kompatibilitätskanal für Workflows, die Websuchtools benötigen.",
    "codexSettings.save": "Speichern Sie den Kanal Codex",
    "imageEditor.title": "Eingabebild bearbeiten",
    "imageEditor.promptHint": "Handgezeichnete Pfeile und Markierungen im Bild sind lediglich Hinweise. Behalten Sie sie nicht im endgültigen Bild bei.",
    "imageEditor.inputFallback": "Eingabebild",
    "imageEditor.openFailed": "Dieses Bild konnte nicht zur Bearbeitung geöffnet werden",
    "imageEditor.loadForEditFailed": "Dieses Bild konnte nicht zur Bearbeitung geladen werden",
    "imageEditor.canvasCreateFailed": "Die Bildbearbeitungsfläche konnte nicht erstellt werden",
    "imageEditor.closedRegionRequired": "Zeichnen Sie zunächst mit dem Pinsel einen geschlossenen Bereich",
    "imageEditor.saveFailed": "Bildbearbeitung konnte nicht gespeichert werden",
    "imageEditor.saved": "Bearbeitetes Eingabebild gespeichert",
    "imageEditor.uneditable": "Dieses Bild kann nicht bearbeitet werden",
    "imageEditor.resetDone": "Auf Originalbild zurücksetzen",
    "imageEditor.resetFailed": "Das Originalbild konnte nicht zurückgesetzt werden",
    "imageEditor.subtitle": "Zuschneiden, zeichnen, füllen oder Pfeile hinzufügen und dann als neues Eingabebild speichern",
    "imageEditor.toolbar": "Symbolleiste des Bildeditors",
    "imageEditor.tools": "Werkzeuge",
    "imageEditor.select": "Auswählen",
    "imageEditor.brush": "Pinsel",
    "imageEditor.arrow": "Pfeil",
    "imageEditor.crop": "Zuschneiden",
    "imageEditor.fill": "Füllen",
    "imageEditor.fillLabel": "Farbeimer füllen",
    "imageEditor.eraser": "Radierer",
    "imageEditor.colors": "Farben",
    "imageEditor.red": "Rot",
    "imageEditor.blue": "Blau",
    "imageEditor.green": "Grün",
    "imageEditor.yellow": "Gelb",
    "imageEditor.white": "Weiß",
    "imageEditor.black": "Schwarz",
    "imageEditor.customColor": "Benutzerdefinierte Farbe",
    "imageEditor.stroke": "Schlaganfall",
    "imageEditor.history": "Geschichte",
    "imageEditor.undo": "Rückgängig machen",
    "imageEditor.redo": "Wiederholen",
    "imageEditor.reset": "Bild zurücksetzen",
    "imageEditor.canvas": "Bildbearbeitungsleinwand",
    "imageEditor.canvasScope": "Leinwandbereich",
    "imageEditor.canvasScopeBase": "Erstes Bild",
    "imageEditor.canvasScopeFit": "An Ebenen anpassen",
    "imageEditor.canvasFitDone": "Leinwand an Ebenenbereich angepasst",
    "imageEditor.canvasBaseDone": "Leinwand auf erstes Bild zurückgesetzt",
    "imageEditor.insertImages": "Bilder einfügen",
    "imageEditor.layers": "Ebenen",
    "imageEditor.layerUp": "Nach oben",
    "imageEditor.layerDown": "Nach unten",
    "imageEditor.emptyInsertList": "Keine weiteren Eingabebilder",
    "imageEditor.selectLayerFirst": "Wählen Sie zuerst eine Ebene aus",
    "imageEditor.baseLayer": "Basisbild",
    "gallery.title": "Galerie",
    "gallery.subtitle": "Wählen Sie Referenzbilder für die aktuelle Aufgabe",
    "gallery.manageCategories": "Kategorien verwalten",
    "gallery.categoryManager": "Galeriekategorien verwalten",
    "gallery.categoryManagement": "Kategoriemanagement",
    "gallery.categoryCopy": "Kategorien werden in der Galerie gespeichert; Eingabeaufforderungsrollen beschreiben, wie Referenzen verwendet werden.",
    "gallery.newCategoryName": "Neuer Kategoriename",
    "gallery.newCategoryRole": "Schnelle Rolle, z.B. Stilreferenz",
    "gallery.addCategory": "Kategorie hinzufügen",
    "gallery.drawerSubtitle": "Aktuelle Kategorie: {category}. Klicken Sie auf „Verwenden“, um es zur Bildeingabe hinzuzufügen.",
    "gallery.emptyCategory": "Noch keine Bilder in dieser Kategorie",
    "gallery.dragSort": "Zum Sortieren ziehen",
    "gallery.dragSortImage": "Bild durch Ziehen und Sortieren {name}",
    "gallery.dragSortCategory": "Drag-Sort-Kategorie {name}",
    "gallery.use": "Benutzen",
    "gallery.replace": "Ersetzen",
    "gallery.rename": "Umbenennen",
    "gallery.moveCategory": "Kategorie",
    "gallery.note": "Hinweis",
    "gallery.delete": "Löschen",
    "gallery.uncategorized": "Nicht kategorisiert",
    "addGallery.title": "Zur Galerie hinzufügen",
    "addGallery.copy": "Namen sind weltweit eindeutig und können später mit @name referenziert werden",
    "addGallery.name": "Name",
    "addGallery.namePlaceholder": "Beispiel: Mia",
    "addGallery.category": "Kategorie",
    "addGallery.note": "Referenzhinweis",
    "addGallery.notePlaceholder": "Beispiel: Nur Gesicht und Haare, nicht Kleidung oder Hintergrund",
    "addGallery.save": "In der Galerie speichern",
    "close.promptTemplates": "Schließen Sie den Bereich Eingabeaufforderungsvorlagen",
    "close.archive": "Archivfenster schließen",
    "close.settings": "Schließen Sie das Speichereinstellungsfeld",
    "close.apiSettings": "Schließen Sie das Einstellungsfeld API",
    "close.systemSettings": "Schließen Sie das Systemeinstellungsfeld",
    "close.imageEditor": "Schließen Sie das Bildbearbeitungsfenster",
    "close.gallery": "Galeriefenster schließen",
    "close.addGallery": "Schließen Sie das Fenster „Zur Galerie hinzufügen“.",
    "close.version": "Schließen Sie das Versionsaktualisierungsfenster",
};


